// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_header__Xrmhv {
    background: white;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 99;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

/* ── Top row: logo + user info ── */
.header_topRow__6d67m {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    height: 50px;
    border-bottom: 1px solid #f0f0f0;
}

.header_logo__r\\+g53 h2 {
    font-size: 20px;
    font-weight: bold;
    margin: 0;
    white-space: nowrap;
    animation: header_colorChange__TIZcS 3s infinite alternate;
}

.header_logo__r\\+g53 h2 span {
    display: inline-block;
    opacity: 0;
    transform: translateY(-100%);
    animation: header_dropIn__AWGQG 0.5s forwards;
    animation-delay: calc(0.1s * var(--i));
}

.header_logo__r\\+g53 h2 span:nth-child(1) { --i: 1; }
.header_logo__r\\+g53 h2 span:nth-child(2) { --i: 2; }
.header_logo__r\\+g53 h2 span:nth-child(3) { --i: 3; }
.header_logo__r\\+g53 h2 span:nth-child(4) { --i: 4; }
.header_logo__r\\+g53 h2 span:nth-child(5) { --i: 5; }
.header_logo__r\\+g53 h2 span:nth-child(6) { --i: 6; }
.header_logo__r\\+g53 h2 span:nth-child(7) { --i: 7; }
.header_logo__r\\+g53 h2 span:nth-child(8) { --i: 8; }
.header_logo__r\\+g53 h2 span:nth-child(9) { --i: 9; }

.header_space__IGp0Z {
    display: inline-block;
    width: 5px;
}

@keyframes header_dropIn__AWGQG {
    0%   { opacity: 0; transform: translateY(-100%); }
    100% { opacity: 1; transform: translateY(0); }
}

@keyframes header_colorChange__TIZcS {
    0%   { color: #36C4FF; }
    100% { color: #091126; }
}

.header_userInfo__U0JoL {
    display: flex;
    align-items: center;
    gap: 14px;
}

.header_email__K9Ey9 {
    font-weight: 600;
    font-size: 0.88rem;
    color: #333;
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.header_logoutIcon__7tHfk {
    width: 22px;
    height: 22px;
    cursor: pointer;
    color: #555;
    transition: color 0.2s;
    flex-shrink: 0;
}

.header_logoutIcon__7tHfk:hover {
    color: #d32f2f;
}

/* ── Hamburger button (mobile only) ── */
.header_hamburger__qhxaS {
    display: none;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    cursor: pointer;
    color: #333;
    padding: 4px;
    border-radius: 4px;
    flex-shrink: 0;
}

.header_hamburger__qhxaS svg {
    width: 24px;
    height: 24px;
}

.header_hamburger__qhxaS:hover {
    background: #f0f0f0;
}

/* ── Desktop nav row ── */
.header_navRow__qgh5A {
    display: flex;
    align-items: center;
    overflow-x: auto;
    padding: 0 8px;
    height: 40px;
    background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
    scrollbar-width: none;
    gap: 2px;
}

.header_navRow__qgh5A::-webkit-scrollbar {
    display: none;
}

.header_navLink__hy6fk {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 5px 11px;
    border-radius: 5px;
    text-decoration: none;
    color: rgba(255, 255, 255, 0.8);
    font-size: 0.78rem;
    font-weight: 600;
    white-space: nowrap;
    transition: background 0.18s, color 0.18s;
    flex-shrink: 0;
}

.header_navLink__hy6fk:hover {
    background: rgba(255, 255, 255, 0.18);
    color: #fff;
}

.header_active__8mBmX {
    background: rgba(255, 255, 255, 0.28);
    color: #fff;
    box-shadow: inset 0 0 0 1px rgba(255,255,255,0.3);
}

/* ── Mobile nav dropdown ── */
.header_mobileNav__uI1Ok {
    display: none;
    flex-direction: column;
    background: linear-gradient(180deg, #1e3c72 0%, #2a5298 100%);
    padding: 8px;
    gap: 4px;
    max-height: calc(100vh - 50px);
    overflow-y: auto;
}

.header_mobileNavLink__I8fmo {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    border-radius: 6px;
    text-decoration: none;
    color: rgba(255, 255, 255, 0.85);
    font-size: 0.9rem;
    font-weight: 600;
    transition: background 0.18s, color 0.18s;
}

.header_mobileNavLink__I8fmo:hover {
    background: rgba(255, 255, 255, 0.18);
    color: #fff;
}

.header_mobileActive__g9Z7- {
    background: rgba(255, 255, 255, 0.28);
    color: #fff;
    box-shadow: inset 0 0 0 1px rgba(255,255,255,0.3);
}

/* ── Mobile breakpoint ── */
@media (max-width: 768px) {
    .header_navRow__qgh5A {
        display: none;
    }

    .header_hamburger__qhxaS {
        display: flex;
    }

    .header_mobileNav__uI1Ok {
        display: flex;
    }

    .header_email__K9Ey9 {
        max-width: 120px;
        font-size: 0.78rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/header.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,WAAW;IACX,yCAAyC;AAC7C;;AAEA,oCAAoC;AACpC;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,mBAAmB;IACnB,0DAA4C;AAChD;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,4BAA4B;IAC5B,6CAA+B;IAC/B,sCAAsC;AAC1C;;AAEA,4CAA6B,MAAM,EAAE;AACrC,4CAA6B,MAAM,EAAE;AACrC,4CAA6B,MAAM,EAAE;AACrC,4CAA6B,MAAM,EAAE;AACrC,4CAA6B,MAAM,EAAE;AACrC,4CAA6B,MAAM,EAAE;AACrC,4CAA6B,MAAM,EAAE;AACrC,4CAA6B,MAAM,EAAE;AACrC,4CAA6B,MAAM,EAAE;;AAErC;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,OAAO,UAAU,EAAE,4BAA4B,EAAE;IACjD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AACjD;;AAEA;IACI,OAAO,cAAc,EAAE;IACvB,OAAO,cAAc,EAAE;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,yCAAyC;AACzC;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,6DAA6D;IAC7D,qBAAqB;IACrB,QAAQ;AACZ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX,iDAAiD;AACrD;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,sBAAsB;IACtB,6DAA6D;IAC7D,YAAY;IACZ,QAAQ;IACR,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,WAAW;IACX,iDAAiD;AACrD;;AAEA,4BAA4B;AAC5B;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;AACJ","sourcesContent":[".header {\n    background: white;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    z-index: 99;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n}\n\n/* ── Top row: logo + user info ── */\n.topRow {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 20px;\n    height: 50px;\n    border-bottom: 1px solid #f0f0f0;\n}\n\n.logo h2 {\n    font-size: 20px;\n    font-weight: bold;\n    margin: 0;\n    white-space: nowrap;\n    animation: colorChange 3s infinite alternate;\n}\n\n.logo h2 span {\n    display: inline-block;\n    opacity: 0;\n    transform: translateY(-100%);\n    animation: dropIn 0.5s forwards;\n    animation-delay: calc(0.1s * var(--i));\n}\n\n.logo h2 span:nth-child(1) { --i: 1; }\n.logo h2 span:nth-child(2) { --i: 2; }\n.logo h2 span:nth-child(3) { --i: 3; }\n.logo h2 span:nth-child(4) { --i: 4; }\n.logo h2 span:nth-child(5) { --i: 5; }\n.logo h2 span:nth-child(6) { --i: 6; }\n.logo h2 span:nth-child(7) { --i: 7; }\n.logo h2 span:nth-child(8) { --i: 8; }\n.logo h2 span:nth-child(9) { --i: 9; }\n\n.space {\n    display: inline-block;\n    width: 5px;\n}\n\n@keyframes dropIn {\n    0%   { opacity: 0; transform: translateY(-100%); }\n    100% { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes colorChange {\n    0%   { color: #36C4FF; }\n    100% { color: #091126; }\n}\n\n.userInfo {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n}\n\n.email {\n    font-weight: 600;\n    font-size: 0.88rem;\n    color: #333;\n    max-width: 180px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.logoutIcon {\n    width: 22px;\n    height: 22px;\n    cursor: pointer;\n    color: #555;\n    transition: color 0.2s;\n    flex-shrink: 0;\n}\n\n.logoutIcon:hover {\n    color: #d32f2f;\n}\n\n/* ── Hamburger button (mobile only) ── */\n.hamburger {\n    display: none;\n    align-items: center;\n    justify-content: center;\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: #333;\n    padding: 4px;\n    border-radius: 4px;\n    flex-shrink: 0;\n}\n\n.hamburger svg {\n    width: 24px;\n    height: 24px;\n}\n\n.hamburger:hover {\n    background: #f0f0f0;\n}\n\n/* ── Desktop nav row ── */\n.navRow {\n    display: flex;\n    align-items: center;\n    overflow-x: auto;\n    padding: 0 8px;\n    height: 40px;\n    background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);\n    scrollbar-width: none;\n    gap: 2px;\n}\n\n.navRow::-webkit-scrollbar {\n    display: none;\n}\n\n.navLink {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    padding: 5px 11px;\n    border-radius: 5px;\n    text-decoration: none;\n    color: rgba(255, 255, 255, 0.8);\n    font-size: 0.78rem;\n    font-weight: 600;\n    white-space: nowrap;\n    transition: background 0.18s, color 0.18s;\n    flex-shrink: 0;\n}\n\n.navLink:hover {\n    background: rgba(255, 255, 255, 0.18);\n    color: #fff;\n}\n\n.active {\n    background: rgba(255, 255, 255, 0.28);\n    color: #fff;\n    box-shadow: inset 0 0 0 1px rgba(255,255,255,0.3);\n}\n\n/* ── Mobile nav dropdown ── */\n.mobileNav {\n    display: none;\n    flex-direction: column;\n    background: linear-gradient(180deg, #1e3c72 0%, #2a5298 100%);\n    padding: 8px;\n    gap: 4px;\n    max-height: calc(100vh - 50px);\n    overflow-y: auto;\n}\n\n.mobileNavLink {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 12px 16px;\n    border-radius: 6px;\n    text-decoration: none;\n    color: rgba(255, 255, 255, 0.85);\n    font-size: 0.9rem;\n    font-weight: 600;\n    transition: background 0.18s, color 0.18s;\n}\n\n.mobileNavLink:hover {\n    background: rgba(255, 255, 255, 0.18);\n    color: #fff;\n}\n\n.mobileActive {\n    background: rgba(255, 255, 255, 0.28);\n    color: #fff;\n    box-shadow: inset 0 0 0 1px rgba(255,255,255,0.3);\n}\n\n/* ── Mobile breakpoint ── */\n@media (max-width: 768px) {\n    .navRow {\n        display: none;\n    }\n\n    .hamburger {\n        display: flex;\n    }\n\n    .mobileNav {\n        display: flex;\n    }\n\n    .email {\n        max-width: 120px;\n        font-size: 0.78rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `header_header__Xrmhv`,
	"topRow": `header_topRow__6d67m`,
	"logo": `header_logo__r+g53`,
	"colorChange": `header_colorChange__TIZcS`,
	"dropIn": `header_dropIn__AWGQG`,
	"space": `header_space__IGp0Z`,
	"userInfo": `header_userInfo__U0JoL`,
	"email": `header_email__K9Ey9`,
	"logoutIcon": `header_logoutIcon__7tHfk`,
	"hamburger": `header_hamburger__qhxaS`,
	"navRow": `header_navRow__qgh5A`,
	"navLink": `header_navLink__hy6fk`,
	"active": `header_active__8mBmX`,
	"mobileNav": `header_mobileNav__uI1Ok`,
	"mobileNavLink": `header_mobileNavLink__I8fmo`,
	"mobileActive": `header_mobileActive__g9Z7-`
};
export default ___CSS_LOADER_EXPORT___;
